import React from "react"
import styled from "styled-components"
import PropTypes from "prop-types"
import SweetAlert from "react-bootstrap-sweetalert"
import { copyToClipboard } from "../../../helpers/utils"

const TokenSweetAlert = ({ data: { agency_name, token } = {}, onConfirm }) => {

  const [isCopy, setIsCopy] = React.useState(false)

  React.useEffect(() => {
    if (!isCopy) return void 0;

    setTimeout(() => {
      setIsCopy(false)
    }, 2000)
  }, [isCopy])

  const onClickCopy = () => {
    copyToClipboard(token)
    setIsCopy(true)
  }

  return (
    <SweetAlert
      title={agency_name}
      onConfirm={onConfirm}
    >
      <StyledContainer>
        <strong>Token: </strong>
        {token ? <>
          <span>{token}</span>
          <button onClick={onClickCopy}><i className={`${!isCopy ? 'bx bx-copy' : 'mdi mdi-check-bold'}`}/></button>
        </> : <span>N/A</span>}
      </StyledContainer>
    </SweetAlert>
  )
}

TokenSweetAlert.propTypes = {
  data: PropTypes.object,
  onConfirm: PropTypes.func
}

const StyledContainer = styled.p`
  max-width: 200px;
  text-align: center;
  margin: auto;
  display: flex;
  align-items: center;
  
  strong { margin-right: 5px }
  
  span {
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
  }
  
  button {
    background-color: transparent;
    border: none;
    outline: none;
    
    &:hover {
      i {
        color: rgb(85,110,230);
      }
    }
  }
  
`

export default (TokenSweetAlert)
